<template>
  <div style="display: flex;">

    <div class="menu" :class="{ 'menu-admin': isAdmin, 'menu-user': !isAdmin }">
      <el-menu class="my_el_menu" background-color="#F5F6F7" text-color="#363b4c" active-text-color="#1e6fff"
        :default-active="activeMenuId">
        <el-menu :default-active="activeMenuId" :default-openeds="defaultOpeneds" background-color="#F5F6F7"
          text-color="#363b4c" active-text-color="#1e6fff" class="menu">
          <el-submenu index="1">
            <template slot="title">
              <span @click="handleAllClick">
                <i class="el-icon-folder"></i>
                <span>全部文件</span>
              </span>
            </template>
            <files_menu :data="treeData" @node-click="handleNodeClick"></files_menu>
          </el-submenu>
        </el-menu>
      </el-menu>
    </div>
    <div class="myFileBox">
      <split-pane :splitSet="splitSet">
        <template slot="paneL">
          <div style="
          margin-left: 20px; margin-top: 10px;">
            <el-button v-has="'addFileButton'" type="primary" size="small" icon="el-icon-edit-outline"
              @click="operation(previewFile, 'addFolder')" title="新增文件夹">新增文件夹</el-button>
            <el-button v-has="'addFileButton'" type="primary" size="small" icon="el-icon-edit-outline"
              @click="operation(previewFile, 'uploadFile')" title="上传文件">上传文件</el-button>
          </div>
          <div style="margin:10px 20px;">
            <!-- 高级搜索按钮 -->
            <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px;">
              <el-input placeholder="请输入文件名" v-model="searchParams.keyword" clearable @change="handleNormalSearch"
                style="flex: 1;" :disabled="!!searchParams.contentKeyword">
                <i slot="prefix" class="el-input__icon el-icon-document"></i>
              </el-input>
              <el-button :type="showAdvancedSearch ? 'primary' : ''"
                :icon="showAdvancedSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="toggleAdvancedSearch">
                {{ showAdvancedSearch ? '收起' : '高级' }}
              </el-button>
            </div>

            <!-- 高级搜索选项 -->
            <el-collapse-transition>
              <div v-show="showAdvancedSearch" class="advanced-search-panel">
                <el-form :model="searchParams" label-width="70px" size="small">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <!-- <el-form-item  > -->
                      <el-select v-model="searchParams.status" placeholder="请选择状态" clearable style="width: 100%;"
                        @change="handleNormalSearch" :disabled="!!searchParams.contentKeyword">
                        <el-option label="草稿" :value="0"></el-option>
                        <el-option label="待审核" :value="1"></el-option>
                        <el-option label="已生效" :value="2"></el-option>
                        <el-option label="已废止" :value="-1"></el-option>
                      </el-select>
                      <!-- </el-form-item> -->
                    </el-col>
                    <el-col :span="12">
                      <!-- <el-form-item > -->
                      <el-input v-model="searchParams.version" placeholder="如：1.0" @change="handleNormalSearch"
                        clearable :disabled="!!searchParams.contentKeyword">
                        <template slot="prepend">V</template>
                      </el-input>
                      <!-- </el-form-item> -->
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" style="margin-top: 8px;">
                    <el-col :span="24">
                      <el-input v-model="searchParams.contentKeyword" placeholder="请输入文件内容关键词" clearable
                        :disabled="!!(searchParams.keyword || searchParams.status !== null && searchParams.status !== '' || searchParams.version)"
                        @change="handleContentKeywordChange">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        <!-- <template slot="prepend">内容</template> -->
                      </el-input>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-transition>
          </div> <el-breadcrumb separator="" style="margin:14px 20px;font-size: 14px;">
            <el-breadcrumb-item v-if="!isSearching">
              <span style="cursor: pointer;" @click="handleAllClick">全部文件 ></span>
            </el-breadcrumb-item>
            <template v-if="!isSearching">
              <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.folderId || item.id">
                <span @click="toggleBreadcrumb(item)" style="cursor: pointer;">{{ item.folderName || item.name }}
                  ></span>
              </el-breadcrumb-item></template>

            <el-breadcrumb-item v-if="isSearching">
              <span style="color: #409eff;">
                <i class="el-icon-search"></i>
                搜索结果: {{ getSearchDisplayText() }} ({{ fileList.length }} 个文件)
              </span>
            </el-breadcrumb-item>
          </el-breadcrumb>


          <div v-loading="loading" :class="isAdmin ? 'panel-admin' : 'panel'" id="panel" @click="panelClick()" :style="isAdmin && showAdvancedSearch ? 'height: calc(100vh - 375px);' :
            isAdmin && !showAdvancedSearch ? 'height: calc(100vh - 255px);' :
              !isAdmin && showAdvancedSearch ? 'height: calc(100vh - 280px);' : 'height: calc(100vh - 150px);'">
            <!-- 批量审批确定按钮 -->
            <div style="margin:0px 12px;" v-if="batchApprovalMode" class="batch-approval-actions">
              <el-button type="primary" size="small" @click="confirmBatchApproval"
                :disabled="selectedFiles.length === 0">
                确定提交审批 ({{ selectedFiles.length }})
              </el-button>
              <el-button size="small" @click="cancelBatchApproval">取消</el-button>
            </div>
            <!-- 文件对比确定按钮 -->
            <div style="margin:0px 12px;" v-if="compareMode" class="compare-actions">
              <el-button type="primary" size="small" @click="confirmCompare" :disabled="compareFiles.length !== 2">
                确定对比 ({{ compareFiles.length }}/2)
              </el-button>
              <el-button size="small" @click="cancelCompare">取消</el-button>
            </div>
            <el-empty v-if="fileList == null || fileList.length === 0" description="该文件夹暂无文件！"></el-empty>
            <div class="fileBox" v-else>
              <div class="box" v-for="(item, index) in fileList" :key="index">
                <folderBox v-if="item.type === 'folder'" :id="item.id" :info="item" @click.native="dbClickFolder(item)"
                  @click-more="clickMore" @ok="refresh"></folderBox>
                <fileBox v-if="item.type === 'file'" :id="item.id" :info="item" :selected="selectedFileId === item.id"
                  @checkChange="handleFileCheckChange" :batch-approval-mode="batchApprovalMode"
                  @enterBatchApprovalMode="enterBatchApprovalMode" :compare-mode="compareMode"
                  @compareCheckChange="handleCompareCheckChange" @enterCompareMode="enterCompareMode"
                  @click.native.stop="handleFileClick(item)" @click-more="clickMore" @ok="refresh"></fileBox>
              </div>
            </div>
          </div>

        </template>
        <template slot="paneR">

          <div v-if="previewFile" class="preview-panel">
            <div class="preview-header">
              <span class="preview-title" :title="previewFile.fileName"
                :style="previewFile && previewFile.tags && previewFile.tags.length > 0 ? 'min-width: 25%; max-width: 25%;' : ''">{{
                  previewFile.fileName
                }}</span>

              <div style="display: flex;">
                <div class="preview-tags" v-if="previewFile && previewFile.tags && previewFile.tags.length > 0">
                  <el-tag v-for="item in previewFile.tags" size="mini" :key="item.dictItemLabel"
                    style="margin: 0 1px;">{{
                      item.dictItemLabel }}</el-tag>
                </div>
                <div class="preview-actions">
                  <el-button icon="el-icon-share" v-if="previewFile && previewFile.status === 2"
                  @click="operation(previewFile, 'share')" title="分享">分享</el-button>
                 
                  <el-button icon="el-icon-full-screen" @click="openFullScreenPreview" title="全屏预览">全屏</el-button>
                  <el-button v-if="previewFile && !previewFile.isCompareResult" type="primary" v-has="'addFileButton'"
                    icon="el-icon-setting" @click="openPermissionSetting" title="设置">设置</el-button>
                  <el-button v-has="'addFileButton'" v-if="previewFile && previewFile.status === 0"
                    :disabled="!previewFile || $config.supportFile.edit.indexOf(previewFile.fileType) === -1"
                    type="primary" icon="el-icon-edit-outline" @click="operation(previewFile, 'edit')"
                    title="在线编辑">编辑</el-button>
                  <el-button v-if="previewFile && !previewFile.isCompareResult" type="primary" icon="el-icon-download"
                    @click="downloadFile(previewFile)" title="下载文件">下载</el-button>


                </div>
              </div>

            </div>
            <div class="preview-content" v-loading="previewLoading">
              <div v-if="previewError" class="preview-error">
                <el-result icon="error" title="预览失败" :subTitle="previewErrorMsg">
                  <template slot="extra">
                    <el-button type="primary" size="small" @click="refreshPreview">重新加载</el-button>
                    <el-button size="small" @click="downloadFile(previewFile)">下载文件</el-button>
                  </template>
                </el-result>
              </div>
              <div v-else-if="!isSupportPreview(previewFile)" class="preview-unsupported">
                <el-result icon="warning" title="不支持预览" subTitle="该文件类型暂不支持在线预览">
                  <template slot="extra">
                    <el-button type="primary" size="small" @click="downloadFile(previewFile)">下载文件</el-button>
                  </template>
                </el-result>
              </div>
              <iframe v-else :key="previewKey" :src="getPreviewUrl(previewFile)" frameborder="0" class="preview-iframe"
                :style="{ transform: `scale(${iframeZoom / 100})`, transformOrigin: 'top left', width: `${10000 / iframeZoom}%`, height: `${10000 / iframeZoom}%` }"
                @load="onPreviewLoad" @error="onPreviewError"></iframe>
            </div>
            <div class="preview-bottom" v-if="previewFile && !previewFile.isCompareResult">
              <div class="preview-bottom-left">
                <div class="numBox">
                  <div class="top-title">
                    <i class="el-icon-user-solid" style="color: #1e6fff;" title="创建人"></i>
                    <!-- <div class="count-title">创建人</div> -->
                  </div>
                  <div class="count">
                    {{ previewFile.createUser || '' }}
                  </div>
                </div>
                <div class="numBox">
                  <div class="top-title">
                    <i class="el-icon-time" style="color: #1e6fff;" title="修改时间"></i>
                    <!-- <div class="count-title">创建时间</div> -->
                  </div>
                  <div class="count">
                    {{ previewFile.updateDate || previewFile.createDate }}
                  </div>
                </div>
                <div class="numBox">
                  <div class="top-title">
                    <i class="el-icon-view" style="color: #1e6fff;" title="浏览量"></i>
                    <!-- <div class="count-title">预览数</div> -->
                  </div>
                  <div class="count">
                    {{ previewFile.viewCount || 0 }}
                  </div>
                </div>
                <div class="numBox">
                  <div class="top-title">
                    <i class="el-icon-download" style="color: #3cb657;" title="下载数"></i>
                    <!-- <div class="count-title">下载数</div> -->

                  </div>
                  <div class="count">
                    {{ previewFile.downloadCount || 0 }}
                  </div>
                </div>
                <div class="numBox" style="cursor: pointer;" @click="showDetail('view')">
                  <div class="top-title">
                    <i class="el-icon-user" style="color: #1e6fff;" title="已查看的人数"></i>
                    <!-- <div class="count-title">下载数</div> -->

                  </div>
                  <div class="count">
                    <span>{{ previewFile.viewPersonNumber || 0 }}</span>
                  </div>
                </div>
                <div class="numBox" style="cursor: pointer;" v-has="'addFileButton'" @click="showDetail('operate')">
                  <div class="top-title">
                    <i class="el-icon-edit-outline"></i>
                    <div class="count-title">操作记录</div>

                  </div>
                  <!-- <div class="count">
                    {{ previewFile.editCount || 0 }}
                  </div> -->
                </div>
              </div>


              <div class="zoom-controls">
                <div class="zoom-label">
                  <i class="el-icon-zoom-in"></i>
                  <!-- <span>缩放</span> -->
                </div>
                <el-button-group>
                  <el-button size="small" icon="el-icon-minus" @click="zoomOut"
                    :disabled="iframeZoom <= 10"></el-button>
                  <el-button size="small" @click="resetZoom">{{ iframeZoom }}%</el-button>
                  <el-button size="small" icon="el-icon-plus" @click="zoomIn" :disabled="iframeZoom >= 200"></el-button>
                </el-button-group>
              </div>
            </div>
          </div>

          <div v-else-if="previewFolder" class="preview-panel">
            <div class="preview-header">
              <span class="preview-title">

                <i class="el-icon-folder-opened" style="color: #409eff; margin-right: 8px;"></i>
                {{ previewFolder.folderName || '' }}
              </span>

              <div class="preview-actions">
                <el-button type="primary" v-has="'addFileButton'" icon="el-icon-setting" @click="openPermissionSetting"
                  title="权限设置">权限设置</el-button>
                <el-button type="text" icon="el-icon-close" @click="closePreview" title="关闭预览"></el-button>
              </div>
            </div>
            <div class="preview-content folder-detail-content">
              <div class="folder-info-section">
                <!-- <div class="section-title">
                  <i class="el-icon-info"></i>
                  <span>基本信息</span>
                </div> -->
                <div class="info-grid">
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-lock" style="color: #606266;"></i>
                      <span>权限类型</span>
                    </div>
                    <div class="info-value">
                      <el-tag :type="previewFolder.publicFlag === 1 ? 'success' : 'info'" size="small">
                        {{ previewFolder.publicFlag === 1 ? '公开' : '私有' }}
                      </el-tag>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-folder-opened" style="color: #f56c6c;"></i>
                      <span>文件数量</span>
                    </div>
                    <div class="info-value">{{ previewFolderList.fileCount }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-view" style="color: #409eff;"></i>
                      <span>浏览总次数</span>
                    </div>
                    <div class="info-value">{{ previewFolderList.totalViewCount }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-download" style="color: #67c23a;"></i>
                      <span>下载总次数</span>
                    </div>
                    <div class="info-value">{{ previewFolderList.totalDownloadCount }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-edit" style="color: #e6a23c;"></i>
                      <span>编辑次数</span>
                    </div>
                    <div class="info-value">{{ previewFolderList.totalEditCount }}</div>
                  </div>

                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-user" style="color: #409eff;"></i>
                      <span>创建人</span>
                    </div>
                    <div class="info-value">{{ previewFolder.createUser }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-time" style="color: #67c23a;"></i>
                      <span>创建时间</span>
                    </div>
                    <div class="info-value">{{ previewFolder.createDate }}</div>
                  </div>
                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-user" style="color: #e6a23c;"></i>
                      <span>更新人</span>
                    </div>
                    <div class="info-value">{{ previewFolder.updateUser }}</div>
                  </div>


                  <div class="info-item">
                    <div class="info-label">
                      <i class="el-icon-time" style="color: #f56c6c;"></i>
                      <span>更新时间</span>
                    </div>
                    <div class="info-value">{{ previewFolder.updateDate }}</div>
                  </div>

                </div>
              </div>

              <div class="folder-info-section" v-if="previewFolder.permissions">
                <div class="section-title">
                  <i class="el-icon-key"></i>
                  <span>权限信息</span>
                </div>
                <div class="permissions-info">
                  <el-tag type="info" size="small">{{ previewFolder.permissions }}</el-tag>
                </div>
              </div>

              <!-- <div class="folder-stats-section">
                <div class="section-title">
                  <i class="el-icon-data-analysis"></i>
                  <span>文件夹统计</span>
                </div>
                <div class="stats-grid">
                  <div class="stat-card">
                    <div class="stat-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                      <i class="el-icon-folder"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">子文件夹</div>
                      <div class="stat-value">{{ previewFolder.folderCount || 0 }}</div>
                    </div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
                      <i class="el-icon-document"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">文件数量</div>
                      <div class="stat-value">{{ previewFolder.fileCount || 0 }}</div>
                    </div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
                      <i class="el-icon-coin"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">总大小</div>
                      <div class="stat-value">{{ formatFileSize(previewFolder.totalSize) }}</div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div v-else class="empty-preview">
            <el-empty description="点击文件进行预览">
              <template slot="image">
                <i class="el-icon-document" style="font-size: 80px; color: #dcdfe6;"></i>
              </template>
            </el-empty>
          </div>
          <!--上传按键-->
          <input multiple="true" :key="fileInputKey" type="file" ref="fileInput" @change="onFileChange"
            style="display: none;" />
          <folderTree ref="folderTree" :title="folderTreeTitle"></folderTree>
          <folderPermissionDialog ref="folderPermissionDialog" :parentId="pid" @ok="getFileDetail" @refresh="refresh"
            @folder="getFolderDetail">
          </folderPermissionDialog>

          <!-- 新增文件夹弹窗 -->
          <el-dialog :title="'新增文件夹到' + folderName || ''" :visible.sync="addFolderDialogVisible" width="550px"
            :close-on-click-modal="false" @close="addFolderDialogVisible = false">
            <el-form :model="addFolderForm" :rules="addFolderRules" ref="addFolderFormRef" label-width="90px">
              <el-form-item label="名称" prop="folderName">
                <el-input v-model="addFolderForm.folderName" placeholder="请输入文件夹名称" maxlength="20" show-word-limit
                  clearable></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="addFolderDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="confirmAddFolder" :loading="addFolderLoading">确 定</el-button>
            </div>
          </el-dialog>

          <!-- 上传文件弹窗 -->
          <el-dialog :title="'上传文件到' + folderName || ''" :visible.sync="uploadDialogVisible" width="600px"
            :close-on-click-modal="false">
            <el-upload class="upload-demo" drag :action="uploadAction" :auto-upload="false" :file-list="uploadFileList"
              :on-change="handleUploadChange" :on-remove="handleUploadRemove" multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
              <el-button @click="uploadDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="confirmUpload" :loading="uploading">确 定</el-button>
            </div>
          </el-dialog>

          <!-- 操作记录对话框 -->
          <el-dialog title="操作记录" :visible.sync="operationRecordsDialog" width="900px" top="15px"
            :close-on-click-modal="false">
            <el-table :data="operationRecordsList" v-loading="operationRecordsLoading" border
              height="calc(100vh - 200px)" stripe>
              <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
              <el-table-column prop="username" label="操作人" width="120" align="center"></el-table-column>
              <el-table-column prop="type" label="操作类型" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.type === 1 ? 'success' : 'warning'" size="small">
                    {{ scope.row.type === 1 ? '查看' : '编辑' }}
                  </el-tag>
                </template>
              </el-table-column> <el-table-column prop="duration" label="用时" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.duration >= 0">{{ formatDuration(scope.row.duration) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="开始时间" width="160" align="center"></el-table-column>
              <el-table-column prop="endTime" label="结束时间" width="160" align="center"></el-table-column>

            </el-table>

            <!-- 分页组件 -->
            <el-pagination @size-change="handleOperationRecordsSizeChange"
              @current-change="handleOperationRecordsPageChange" :current-page="operationRecordsPagination.curPage"
              :page-sizes="[10, 20, 50, 100]" :page-size="operationRecordsPagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="operationRecordsPagination.total"
              style="margin-top: 20px; text-align: right;">
            </el-pagination>


          </el-dialog>

          <!-- 查看记录对话框 -->
          <el-dialog title="查看详情" :visible.sync="viewRecordsDialog" width="800px" top="15px"
            :close-on-click-modal="false">
            <div v-loading="viewRecordsLoading">
              <div v-if="viewRecordsData" class="view-records-container">
                <!-- 统计信息 -->
                <div class="statistics-section">
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <div class="stat-card">
                        <!-- <div class="stat-icon total">
                          <i class="el-icon-user-solid"></i>
                        </div> -->
                        <div class="stat-content">
                          <div class="stat-label"> <i class="el-icon-user-solid stat-icon total"></i>总人数</div>
                          <div class="stat-value">{{ viewRecordsData.totalCount || 0 }}</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="stat-card">
                        <!-- <div class="stat-icon read">
                          <i class="el-icon-view"></i>
                        </div> -->
                        <div class="stat-content">
                          <div class="stat-label"> <i class="el-icon-view stat-icon read"></i>
                            已读人数</div>
                          <div class="stat-value">{{ viewRecordsData.readCount || 0 }}</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="stat-card">
                        <!-- <div class="stat-icon unread">
                          <i class="el-icon-warning-outline"></i>
                        </div> -->
                        <div class="stat-content">
                          <div class="stat-label"> <i class="el-icon-warning-outline stat-icon unread"></i>
                            未读人数</div>
                          <div class="stat-value">{{ viewRecordsData.unreadCount || 0 }}</div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <!-- 已读人员列表 -->
                  <div class="user-list-section">
                    <div class="section-header">
                      <i class="el-icon-success"></i>
                      <span>已读人员 ({{ viewRecordsData.readCount || 0 }})</span>
                    </div>
                    <div class="user-list">
                      <el-tag v-for="(user, index) in viewRecordsData.readUsers" :key="'read-' + index" type="success"
                        size="medium" class="user-tag">
                        <i class="el-icon-user"></i>
                        {{ user.fullName }}
                      </el-tag>
                      <el-empty v-if="!viewRecordsData.readUsers || viewRecordsData.readUsers.length === 0"
                        description="暂无已读人员" :image-size="80"></el-empty>
                    </div>
                  </div>

                  <!-- 未读人员列表 -->
                  <div class="user-list-section">
                    <div class="section-header">
                      <i class="el-icon-warning"></i>
                      <span>未读人员 ({{ viewRecordsData.unreadCount || 0 }})</span>
                    </div>
                    <div class="user-list">
                      <el-tag v-for="(user, index) in viewRecordsData.unreadUsers" :key="'unread-' + index" type="info"
                        size="medium" class="user-tag">
                        <i class="el-icon-user"></i>
                        {{ user.fullName }}
                      </el-tag>
                      <el-empty v-if="!viewRecordsData.unreadUsers || viewRecordsData.unreadUsers.length === 0"
                        description="暂无未读人员" :image-size="80"></el-empty>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </el-dialog>

          <!-- 全屏预览对话框 -->
          <el-dialog title="" :visible.sync="fullScreenPreviewDialog" fullscreen :show-close="false"
            :close-on-click-modal="false" :close-on-press-escape="true" custom-class="fullscreen-preview-dialog">
            <div class="fullscreen-preview-container">
              <!-- 顶部工具栏 -->
              <div class="fullscreen-toolbar">
                <div class="toolbar-left">
                  <i class="el-icon-document" style="font-size: 20px; color: #409eff; margin-right: 10px;"></i>
                  <span class="file-name">{{ previewFile ? previewFile.fileName : '' }}</span>
                  <div v-if="previewFile && previewFile.tags && previewFile.tags.length > 0">
                    <el-tag v-for="item in previewFile.tags" size="mini" :key="item.dictItemLabel"
                      style="margin: 0 1px;">{{
                        item.dictItemLabel }}</el-tag>
                  </div>
                </div>
                <div class="toolbar-right">
                  <el-button-group>
                    <el-button size="small" icon="el-icon-minus" @click="fullScreenZoomOut"
                      :disabled="fullScreenZoom <= 10">缩小</el-button>
                    <el-button size="small" @click="fullScreenResetZoom">{{ fullScreenZoom }}%</el-button>
                    <el-button size="small" icon="el-icon-plus" @click="fullScreenZoomIn"
                      :disabled="fullScreenZoom >= 200">放大</el-button>
                  </el-button-group>
                  <el-button icon="el-icon-share" v-if="previewFile && previewFile.status === 2" size="small"
                    @click="operation(previewFile, 'share')" title="分享">分享</el-button>
                  <el-button size="small" icon="el-icon-full-screen" @click="closeFullScreenPreview"
                    title="全屏预览">取消全屏</el-button>
                  <el-button v-has="'addFileButton'" size="small" v-if="previewFile && !previewFile.isCompareResult"
                    :disabled="!previewFile || $config.supportFile.edit.indexOf(previewFile.fileType) === -1"
                    type="primary" icon="el-icon-edit-outline" @click="operation(previewFile, 'edit')"
                    title="在线编辑">编辑</el-button>
                  <el-button size="small" v-if="previewFile && !previewFile.isCompareResult" icon="el-icon-download"
                    type="primary" @click="downloadFile(previewFile)" style="margin-left: 10px;">下载</el-button>
                  <!-- <el-button size="small" icon="el-icon-close" @click="closeFullScreenPreview" style="margin-left: 10px;">关闭</el-button> -->
                </div>
              </div>

              <!-- 预览内容区域 -->
              <div class="fullscreen-preview-content" v-loading="fullScreenPreviewLoading">
                <div v-if="fullScreenPreviewError" class="preview-error">
                  <el-result icon="error" title="预览失败" :subTitle="fullScreenPreviewErrorMsg">
                    <template slot="extra">
                      <el-button type="primary" size="small" @click="refreshFullScreenPreview">重新加载</el-button>
                      <el-button size="small" @click="downloadFile(previewFile)">下载文件</el-button>
                    </template>
                  </el-result>
                </div>
                <div v-else-if="!isSupportPreview(previewFile)" class="preview-unsupported">
                  <el-result icon="warning" title="不支持预览" subTitle="该文件类型暂不支持在线预览">
                    <template slot="extra">
                      <el-button type="primary" size="small" @click="downloadFile(previewFile)">下载文件</el-button>
                    </template>
                  </el-result>
                </div>
                <iframe v-else :key="fullScreenPreviewKey" :src="getPreviewUrl(previewFile)" frameborder="0"
                  class="fullscreen-preview-iframe" :style="{
                    transform: `scale(${fullScreenZoom / 100})`,
                    transformOrigin: 'top left',
                    width: `${10000 / fullScreenZoom}%`,
                    height: `${10000 / fullScreenZoom}%`
                  }" @load="onFullScreenPreviewLoad" @error="onFullScreenPreviewError">
                </iframe>
              </div>
            </div>
          </el-dialog>
        </template>
      </split-pane>
      <initiateApprovalModal ref="initiateApprovalModal" @ok="refresh"></initiateApprovalModal>

    </div>
  </div>


</template>

<script>
import * as c from '@/utils/config'
import * as u from '@/utils/util'
import splitPane from '@/components/splitPane'
import { version } from 'less';

export default {
  name: "myFile",
  components: {
    'fileTab': () => import('@/components/file/fileTab.vue'),
    'fileBox': () => import('@/components/file/fileBox.vue'),
    'folderBox': () => import('@/components/file/folderBox.vue'),
    'files_menu': () => import('@/components/menu/files_menu.vue'),
    'folderTree': () => import('@/components/folder/folderTree.vue'),
    'folderPermissionDialog': () => import('@/components/folder/folderPermissionDialog.vue'),
    initiateApprovalModal: () => import("@/components/approval/initiateApprovalModal.vue"),

    splitPane
  },
  data() {
    return {
      //加载中
      loading: true,
      search: {
        //文件夹名称
        folderName: "",
      },
      //搜索参数对象
      searchParams: {
        keyword: "",    // 文件名
        status: null,   // 状态：0-草稿，1-待审核，2-已生效，-1-已废止
        version: "",    // 版本号（字符串，支持小数点）
        contentKeyword: ""  // 文件内容关键词
      },
      //是否显示高级搜索
      showAdvancedSearch: false,
      //是否处于搜索状态
      isSearching: false,
      //搜索防抖定时器
      searchTimer: null,
      //当前文件夹父id
      pid: "0",
      //当前文件夹名称
      folderName: '',
      //左侧树形数据
      treeData: [],
      //右侧文件列表
      fileList: [],
      //监听右键tab弹窗状态
      rightTab: {
        show: false,
        top: 0,
        left: 0,
        menu: null,
      },
      //面包屑集合
      breadcrumbList: [],
      userInfo: u.getSession(c.sessionKey.USER_INFO),

      filterText: '',
      //是否已初始化第一个文件夹
      isFirstFolderInitialized: false,
      //当前活跃的菜单项ID
      activeMenuId: '1',
      //默认展开的菜单
      defaultOpeneds: ['1'],
      //当前预览的文件
      previewFile: null,
      //当前预览的文件夹
      previewFolder: null,
      previewFolderList: [],
      //预览加载状态
      previewLoading: false,
      //预览错误状态
      previewError: false,
      //预览错误信息
      previewErrorMsg: '',
      //预览key，用于强制刷新iframe
      previewKey: 0,
      //上传组件key
      fileInputKey: 0,
      //文件树标题
      folderTreeTitle: "解压到",
      //当前选中的文件ID
      selectedFileId: null,
      isAdmin: false,
      //iframe缩放比例
      iframeZoom: 100,
      //操作记录对话框
      operationRecordsDialog: false,
      //操作记录列表
      operationRecordsList: [],
      //操作记录加载状态
      operationRecordsLoading: false,
      //查看记录对话框
      viewRecordsDialog: false,
      //查看记录数据
      viewRecordsData: null,
      //查看记录加载状态
      viewRecordsLoading: false,
      //当前查看文件的开始时间
      currentViewStartTime: null,
      //操作记录分页信息
      operationRecordsPagination: {
        curPage: 1,
        pageSize: 50,
        total: 0
      },
      //全屏预览对话框
      fullScreenPreviewDialog: false,
      //全屏预览加载状态
      fullScreenPreviewLoading: false,
      //全屏预览错误状态
      fullScreenPreviewError: false,
      //全屏预览错误信息
      fullScreenPreviewErrorMsg: '',
      //全屏预览key
      fullScreenPreviewKey: 0,
      //全屏预览缩放比例
      fullScreenZoom: 100,
      //新增文件夹弹窗显示状态
      addFolderDialogVisible: false,
      //新增文件夹表单
      addFolderForm: {
        folderName: ''
      },
      //新增文件夹加载状态
      addFolderLoading: false,
      //新增文件夹表单校验规则
      addFolderRules: {
        folderName: [
          { required: true, message: '请输入文件夹名称', trigger: 'blur' },
          { max: 20, message: '文件夹名称长度不能超过20个字符', trigger: 'blur' }
        ]
      },
      //上传弹窗显示状态
      uploadDialogVisible: false,
      //上传文件列表
      uploadFileList: [],
      //上传中状态
      uploading: false,
      //上传接口地址（仅用于占位，实际不使用）
      uploadAction: '',
      // 批量审批模式
      batchApprovalMode: false,
      // 选中的文件列表
      selectedFiles: [],
      // 文件对比模式
      compareMode: false,
      // 对比模式下选中的文件
      compareFiles: []
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    splitSet() {
      return {
        minPercent: window.innerWidth > 1580 ? 16 : 25,
        maxPercent: 40,
        defaultPercent: window.innerWidth > 1580 ? 25 : 30,
        split: 'vertical'
      }
    },
    //判断是否是普通用户页面
    isMyFileTreePage() {
      return !this.isAdmin;
    },
  },
  created() {
    //加载树形数据并自动打开第一个文件夹
    this.loadTreeData();
  },
  mounted() {
    //判断是否是管理员角色
    this.isAdmin = this.userInfo.roles.includes("149");

    // 监听页面离开事件，记录结束时间
    window.addEventListener('beforeunload', this.recordViewEndTime);

    // 监听退出登录事件，记录结束时间
    // 注意：这里直接传递方法引用，事件参数会作为 callback 传入
    this.$root.$on('before-logout', (callback) => {
      // console.log('收到 before-logout 事件，开始记录结束时间');
      // 设置标志，表示正在退出登录
      this._isLoggingOut = true;
      this.recordViewEndTime(callback);
    });
  },
  beforeDestroy() {
    // 组件销毁前记录结束时间
    // 注意：不传递 callback，因为这是同步销毁，不需要等待
    // 但是要检查是否是因为退出登录导致的销毁，如果是则不记录（因为已经在 before-logout 中记录过了）
    if (!this._isLoggingOut) {
      this.recordViewEndTime();
    }

    // 移除事件监听
    window.removeEventListener('beforeunload', this.recordViewEndTime);
    this.$root.$off('before-logout');

    // 清理对比结果的 Blob URL
    if (this.previewFile && this.previewFile.isCompareResult && this.previewFile.compareUrl) {
      URL.revokeObjectURL(this.previewFile.compareUrl);
    }

    // 立即关闭所有对话框，避免 clickoutside 错误
    this.operationRecordsDialog = false;
    this.fullScreenPreviewDialog = false;
    this.uploadDialogVisible = false;
    this.viewRecordsDialog = false;

    // 清空预览状态
    this.previewFile = null;
    this.previewFolder = null;
  },
  methods: {
    //文件变化监听
    onFileChange(event) {
      this.$parent.loading = true;
      const files = Array.from(event.target.files);

      if (files.length === 0) {
        this.$parent.loading = false;
        return;
      }

      // 将多个文件作为数组上传
      const formData = new FormData();
      files.forEach(file => {
        formData.append('file', file);
      });
      formData.append('folderId', this.pid);

      this.$HttpService.uploadFile(formData).then(() => {
        this.$message.success(`成功上传 ${files.length} 个文件`);
        this.fileInputKey++;
        //刷新表格
        this.refresh()
        this.$parent.loading = false;
      }).catch(() => {
        this.fileInputKey++;
        this.$parent.loading = false;
      })

    },
    //加载树形数据
    loadTreeData() {
      this.$HttpService.get(`/file-folder/tree`, this.search).then(res => {
        this.treeData = res || [];
        // console.log("🚀 ~  this.treeData :",  this.treeData )
        this.loading = false;
        //自动打开第一个文件夹
        if (!this.isFirstFolderInitialized && this.treeData.length > 0) {
          this.isFirstFolderInitialized = true;
          const firstFolder = this.treeData[0];
          if (firstFolder.type === 'folder') {
            //设置第一个文件夹为当前文件夹
            this.pid = firstFolder.folderId;
            this.breadcrumbList = [firstFolder];
            //设置第一个文件夹为活跃状态
            this.activeMenuId = firstFolder.folderId;
            //查询第一个文件夹的内容
            this.findLoginUserFolderByPId(this.pid);
          } else {
            //如果第一个不是文件夹，则查询根目录
            this.findLoginUserFolderByPId(this.pid);
          }
        }
      }).catch(() => {
        this.$message.error('加载文件列表失败');
      })
    },

    //点击顶部“全部文件”时查询根目录
    handleAllClick() {
      this.activeMenuId = '1';
      this.pid = '0';
      this.folderName = ''
      this.breadcrumbList = [];
      this.refresh();
    },

    //按层级查询文件夹
    findLoginUserFolderByPId(pid) {
      this.loading = true;
      this.$HttpService.get(`/file-folder/findLoginUserFolderByPId/${pid}`, this.search).then(res => {
        this.fileList = res;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    //树节点点击事件
    handleNodeClick(data, node) {
      //更新活跃菜单项
      if (this.pid) {
        this.recordViewEndTime();
      }
      this.activeMenuId = data.folderId;
      this.pid = data.folderId;
      this.folderName = data.folderName;
      //点击左侧菜单时，构建完整的面包屑路径
      this.breadcrumbList = this.buildBreadcrumbPath(data.folderId);
      this.getFolderDetail(data.folderId)
      // 清除预览状态
      this.previewFile = null;
      this.previewFolder = null;
      this.selectedFileId = null;
      // 清除搜索状态
      this.searchParams = {
        keyword: '',
        status: null,
        version: '',
        contentKeyword: ''
      };
      this.showAdvancedSearch = false;
      this.isSearching = false;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.refresh();
    },

    //刷新数据
    refresh() {
      // 如果处于搜索状态，执行搜索；否则执行正常查询
      if (this.isSearching && this.searchKeyword) {
        this.searchFiles();
      } else {
        this.findLoginUserFolderByPId(this.pid);
        this.loadTreeData();

      }
    },

    //搜索文件
    searchFiles() {
      // 检查是否有任何搜索条件
      const hasKeyword = this.searchParams.keyword && this.searchParams.keyword.trim();
      const hasStatus = this.searchParams.status !== null && this.searchParams.status !== '';
      const hasVersion = this.searchParams.version && this.searchParams.version.trim();
      const contentKeywordRaw = this.searchParams.contentKeyword && this.searchParams.contentKeyword.trim();
      const hasContentKeyword = contentKeywordRaw && contentKeywordRaw.length >= 2;

      // 内容关键词填写了但不足2个字符，提示并中止
      if (contentKeywordRaw && contentKeywordRaw.length < 2) {
        this.$message.warning('内容关键词至少需要2个字符');
        return;
      }

      if (!hasKeyword && !hasStatus && !hasVersion && !hasContentKeyword) {
        // 如果所有搜索条件都为空，恢复正常列表
        this.isSearching = false;
        this.findLoginUserFolderByPId(this.pid);
        return;
      }

      this.loading = true;
      this.isSearching = true;

      // 构建基础请求参数
      const buildParams = () => {
        const params = {};
        if (hasKeyword) params.keyword = this.searchParams.keyword.trim();
        if (hasStatus) params.status = this.searchParams.status;
        if (hasVersion) params.version = `V${this.searchParams.version.trim()}`;
        return params;
      };

      // 处理搜索结果的公共方法
      const handleResult = (res) => {
        if (res && Array.isArray(res)) {
          this.fileList = res.map(item => ({
            type: 'file',
            id: item.fileId,
            fileInfo: {
              fileId: item.fileId,
              folderId: item.folderId,
              fileName: item.fileName,
              fileSize: item.fileSize,
              fileType: item.fileType,
              filePath: item.filePath,
              createDate: item.createDate,
              createUser: item.createUser,
              deptId: item.deptId,
              updateDate: item.updateDate,
              updateUser: item.updateUser,
              viewCount: item.viewCount,
              editCount: item.editCount,
              downloadCount: item.downloadCount,
              viewPersonNumber: item.viewPersonNumber,
              publicFlag: item.publicFlag,
              status: item.status,
              version: item.version,
              isSearchResult: true
            }
          }));
        } else {
          this.fileList = [];
        }
        this.loading = false;
      };

      if (hasContentKeyword) {
        // 内容搜索：直接使用 /file/search/content 接口的返回结果
        this.$HttpService.post('/file/search/content', { keyword: contentKeywordRaw })
          .then(res => {
            handleResult(res);
          })
          .catch(err => {
            console.error('内容搜索失败:', err);
            this.$message.error('内容搜索失败，请稍后重试');
            this.loading = false;
          });
        return;
      }

      // 普通搜索（无内容关键词）
      const params = buildParams();
      this.$HttpService.post('/file-info/search', params).then(res => {
        handleResult(res);
      }).catch(err => {
        console.error('搜索失败:', err);
        this.$message.error('搜索失败，请稍后重试');
        this.loading = false;
      });
    },

    //处理搜索输入
    handleSearch() {
      // 清除之前的定时器
      // if (this.searchTimer) {
      //   clearTimeout(this.searchTimer);
      // }

      // 使用防抖，避免频繁请求
      // this.searchTimer = setTimeout(() => {
      this.searchFiles();
      // }, 300); // 300ms 防抖延迟
    },

    //普通搜索（文件名/状态/版本）：清除内容关键词，再执行搜索
    handleNormalSearch() {
      this.searchParams.contentKeyword = '';
      this.handleSearch();
    },

    //内容关键词变化：清除其他三个条件，再执行搜索
    handleContentKeywordChange() {
      this.searchParams.keyword = '';
      this.searchParams.status = null;
      this.searchParams.version = '';
      this.handleSearch();
    },

    //清除搜索
    handleSearchClear() {
      this.searchParams = {
        keyword: '',
        status: null,
        version: '',
        contentKeyword: ''
      };
      this.isSearching = false;
      this.showAdvancedSearch = false;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.findLoginUserFolderByPId(this.pid);
    },

    //切换高级搜索显示
    toggleAdvancedSearch() {
      this.showAdvancedSearch = !this.showAdvancedSearch;
    },

    //获取搜索显示文本
    getSearchDisplayText() {
      const conditions = [];

      if (this.searchParams.keyword) {
        conditions.push(`文件名="${this.searchParams.keyword}"`);
      }

      if (this.searchParams.status !== null && this.searchParams.status !== '') {
        const statusMap = {
          '0': '草稿',
          '1': '待审核',
          '2': '已生效',
          '-1': '已废止'
        };
        conditions.push(`状态="${statusMap[this.searchParams.status]}"`);
      }

      if (this.searchParams.version) {
        conditions.push(`版本="v${this.searchParams.version}"`);
      }

      if (this.searchParams.contentKeyword) {
        conditions.push(`内容包含"${this.searchParams.contentKeyword}"`);
      }

      return conditions.join(' + ');
    },

    /**
     * 面板点击事件
     */
    panelClick() {
      // myFileTree 中没有 rightTab，右键菜单在 fileBox 组件内部
      this.selectedFileId = null;
    },


    //操作
    operation(info, code) {
      switch (code) {

        case "addFolder":
          // 打开新增文件夹弹窗
          this.addFolderForm.folderName = '';
          this.addFolderDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.addFolderFormRef && this.$refs.addFolderFormRef.clearValidate();
          });
          break;
        case "rename":
          this.$prompt('请输入文件夹名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: info.folderName,
            inputValidator: val => {
              if (val.length > 20) {
                return "文件夹名称长度不能大于20";
              }
              return true;
            },
          }).then(({ value }) => {
            //判断类型
            if (info.type === 'file') {
              //针对文件重命名
              this.$HttpService.put("/file-info/update", {
                fileId: info.fileId,
                fileName: value,
              }).then(res => {
                this.refresh()
              })

            }
            if (info.type === 'folder') {
              //针对文件夹重命名
              this.$HttpService.put("/file-folder/update", {
                folderId: info.fileId,
                folderName: value,
              }).then(res => {
                this.refresh()
              })
            }
          })
          break;
        case "uploadFile":
          // 打开上传弹窗
          this.uploadDialogVisible = true;
          this.uploadFileList = [];
          break
        case "downloadFile":
          window.location.href = getDownloadFileUrl(info.fileId)
          break;
        case "view":
          //浏览器预览类型
          if (this.$config.supportFile.windowView.indexOf(info.fileInfo.fileType) !== -1) {
            window.open(this.$util.getOpenFileUrl(info.fileId));
          } else {

            window.open(this.$util.getUrlAll(`/file-info/viewFile/${info.fileId}`))
          }
          break;
        case "edit":
          // window.open(this.$util.getUrlAll(`/file-info/editFile/${info.fileId}`))
          // 打开编辑页面
          const editRoute = this.$router.resolve({
            path: `/file/edit/${info.fileId}`
          });
          window.open(editRoute.href, '_blank');
          break;
        case "delete":
          this.$confirm(`是否确认删除${this.typeMap[info.type]}:${info.name}`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //判断类型
            if (info.type === 'file') {
              this.$HttpService.del(`/file-info/delFile/${info.fileId}`).then(() => {
                this.refresh()
              })
            }
            if (info.type === 'folder') {
              this.$HttpService.del(`/file-folder/delFolder/${info.fileId}`).then(() => {
                this.refresh()
              })
            }
          }).catch(() => {
          })
          break;
        case "decompression":
          this.$HttpService.get("/file-folder/findFolderTreeByLogin").then(tree => {
            this.folderTreeTitle = "解压到"
            this.folderTree[0].children = tree;
            this.$refs.folderTree.openDia(this.folderTree, this.decompressionConfim);
          })
          break
        case "toPDF":
          this.$parent.loading = true;
          this.$HttpService.get(`/file-info/fileToPdf/${info.fileId}`).then(() => {
            this.refresh()
            this.$parent.loading = false;
          }).catch(() => {
            this.$parent.loading = false;
          })
          break;
        case "copy":
          this.$HttpService.get("/file-folder/findFolderTreeByLogin").then(tree => {
            this.folderTreeTitle = "复制到"
            this.folderTree[0].children = tree;
            this.$refs.folderTree.openDia(this.folderTree, this.copyConfim);
          })
          break;
        case "move":
          this.$HttpService.get("/file-folder/findFolderTreeByLogin").then(tree => {
            this.folderTreeTitle = "移动到"
            this.folderTree[0].children = tree;
            this.$refs.folderTree.openDia(this.folderTree, this.moveConfim);
          })
          break;
        case "share":
          this.shareFile(info);
          break;
      }
      this.show = false;
    },
    /**
         * 复制到确认事件回调
         * @param node
         */
    copyConfim(node) {
      this.$HttpService
        .post("/file-info/copyFile", {
          fileId: this.info.id,
          folderId: node.folderId,
        })
        .then(() => {
          //知道路径节点集合
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("copyOk", {
            node: node,
            path: nodes,
          });
          this.offDia();
        });
    },

    /**
     * 解压到确认事件回调
     * @param node
     */
    decompressionConfim(node) {
      this.$HttpService
        .post("/file-info/decompression", {
          fileId: this.info.id,
          folderId: node.folderId,
        })
        .then(() => {
          //知道路径节点集合
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("decompressionOk", {
            node: node,
            path: nodes,
          });
          this.offDia();
        });
    },



    /**
     * 批量移动确认回调
     * @param node
     */
    batchMoveConfirm(node) {
      this.$parent.loading = true;
      const movePromises = this.selectedItems.map((item) => {
        if (item.type === "file") {
          return this.$HttpService.post("/file-info/moveFile", {
            fileId: item.id,
            folderId: node.folderId,
          });
        }
        // 可以扩展文件夹移动
        return Promise.resolve();
      });

      Promise.all(movePromises)
        .then(() => {
          this.$message.success("批量移动成功");
          let nodes = this.$util.findTreePath(
            { id: "folderId", children: "children" },
            this.folderTree,
            node.folderId,
          );
          this.$emit("batchOperationComplete");
          this.$parent.loading = false;
        })
        .catch(() => {
          this.$parent.loading = false;
        });
    },
    /**
     * 分享文件
     */
    shareFile(fileInfo) {
      if (!fileInfo || !fileInfo.fileId) {
        this.$message.warning('文件信息不完整');
        return;
      }

      // 生成分享链接
      const baseUrl = window.location.origin;
      const shareUrl = `${baseUrl}/#/share/preview?fileId=${fileInfo.fileId}`;

      // 使用 MessageBox 显示分享链接
      this.$alert(
        `<div style="padding: 10px 0;">
          <div style="margin-bottom: 15px; color: #606266;">
            <i class="el-icon-info" style="color: #409eff; margin-right: 5px;"></i>
            复制以下链接分享给他人：
          </div>
          <div id="shareUrlText" style="background: #f5f7fa; padding: 12px; border-radius: 4px; word-break: break-all; font-family: monospace; font-size: 13px; color: #303133; user-select: all; cursor: text;">
            ${shareUrl}
          </div>
        </div>`,
        '分享文件',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '复制链接',
          cancelButtonText: '关闭',
          showCancelButton: true,
          callback: (action) => {
            if (action === 'confirm') {
              // 同步执行复制操作
              this.copyToClipboardSync(shareUrl);
            }
          }
        }
      );
    },

    /**
     * 同步复制到剪贴板（使用 execCommand）
     */
    copyToClipboardSync(text) {
      try {
        // 创建临时 input 元素
        const input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', text);
        input.style.position = 'fixed';
        input.style.top = '-9999px';
        input.style.left = '-9999px';

        document.body.appendChild(input);

        // iOS 设备特殊处理
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
          input.contentEditable = 'true';
          input.readOnly = false;
          const range = document.createRange();
          range.selectNodeContents(input);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          input.setSelectionRange(0, 999999);
        } else {
          input.select();
          input.setSelectionRange(0, input.value.length);
        }

        // 执行复制
        const successful = document.execCommand('copy');
        document.body.removeChild(input);

        if (successful) {
          this.$message.success('链接已复制到剪贴板');
        } else {
          this.$message.error('复制失败，请手动复制链接');
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败，请手动复制链接');
      }
    },

    /**
     * 鼠标右键事件
     * @param e
     */
    openContextMenu: function (e) {
      if (this.loading) {
        return;
      }
      e.preventDefault(); //防止默认菜单弹出
      //获取当前元素
      let obj = e.srcElement ? e.srcElement : e.target;
      let info = null;
      if (obj.id) {
        //找到当前数据
        info = this.fileList.filter(x => x.id == obj.id)[0];
      }
      this.rightTab.left = e.clientX;
      this.rightTab.top = e.clientY;
      this.$refs.rightTab.openDia(info);
    },

    clickMore(info) {
      this.$refs.rightTab.openDia(info);
    },
    /**
     * 文件点击事件
     * @param item
     */
    handleFileClick(item) {
      // 如果切换到新文件，先记录 结束时间
      if (this.selectedFileId) {
        this.recordViewEndTime();
      }

      // 如果是搜索结果，需要先跳转到文件所在的文件夹
      // if (item.fileInfo && item.fileInfo.isSearchResult && item.fileInfo.folderId) {
      //   this.navigateToFileFolder(item);
      //   return;
      // }

      this.selectedFileId = item.id;
      this.previewLoading = true;
      this.previewError = false;
      this.previewErrorMsg = '';
      // 清除文件夹预览，准备显示文件预览
      this.previewFolder = null;

      // 先获取文件详情，成功后再设置 previewFile
      this.getFileDetail(item.id);
    },

    /**
     * 导航到文件所在的文件夹并预览文件
     * @param item 文件信息
     */
    async navigateToFileFolder(item) {
      try {
        const folderId = item.fileInfo.folderId;

        // 获取文件夹路径
        const folderPath = await this.getFolderPath(folderId);

        // 更新面包屑和当前文件夹
        this.breadcrumbList = folderPath;
        this.pid = folderId;
        this.folderName = folderPath.length > 0 ? folderPath[folderPath.length - 1].folderName : '';

        // 更新活跃菜单项
        this.activeMenuId = folderId;

        // 清除搜索状态
        this.searchParams = {
          keyword: '',
          status: null,
          version: ''
        };
        this.showAdvancedSearch = false;
        this.isSearching = false;

        // 加载文件夹内容
        await this.findLoginUserFolderByPId(this.pid);

        // 预览文件
        this.selectedFileId = item.id;
        this.previewLoading = true;
        this.previewError = false;
        this.previewErrorMsg = '';
        this.previewFolder = null;
        this.getFileDetail(item.id);

        // this.$message.success('已跳转到文件所在位置');
      } catch (error) {
        console.error('跳转失败:', error);
        // this.$message.error('跳转到文件位置失败');
      }
    },

    /**
     * 获取文件夹路径
     * @param folderId 文件夹ID
     * @returns 文件夹路径数组
     */
    async getFolderPath(folderId) {
      if (!folderId || folderId === '0') {
        return [];
      }

      // 从树形数据中查找路径
      return this.buildBreadcrumbPath(folderId);
    },

    getFileDetail(id, record) {
      this.$HttpService.post(`/file-info/detail`, { id: id }).then(res => {
        this.previewFile = res || {};
        this.previewKey++; // 强制刷新iframe
        if (record === false) {
          return
        }
        // 记录查看开始时间
        this.recordViewStartTime();
      }).catch(() => {
        this.$message.error('加载文件详情失败');
        this.previewLoading = false;
      })
    },

    /**
     * 关闭预览
     */
    closePreview() {
      // 如果是对比结果，需要释放 Blob URL
      if (this.previewFile && this.previewFile.isCompareResult && this.previewFile.compareUrl) {
        URL.revokeObjectURL(this.previewFile.compareUrl);
      }

      // 记录结束时间
      this.recordViewEndTime();

      this.previewFile = null;
      this.previewLoading = false;
      this.previewError = false;
      this.previewErrorMsg = '';
      this.selectedFileId = null;
      this.iframeZoom = 100; // 重置缩放
    },

    /**
     * 放大iframe
     */
    zoomIn() {
      if (this.iframeZoom < 200) {
        this.iframeZoom += 10;
      }
    },

    /**
     * 缩小iframe
     */
    zoomOut() {
      if (this.iframeZoom > 10) {
        this.iframeZoom -= 10;
      }
    },

    /**
     * 重置缩放
     */
    resetZoom() {
      this.iframeZoom = 100;
    },

    /**
     * 刷新预览
     */
    refreshPreview() {
      if (this.previewFile) {
        this.previewLoading = true;
        this.previewError = false;
        this.previewErrorMsg = '';
        this.previewKey++; // 强制刷新iframe
      }
    },

    /**
     * 预览加载完成
     */
    onPreviewLoad() {
      this.previewLoading = false;
    },

    /**
     * 预览加载错误
     */
    onPreviewError() {
      this.previewLoading = false;
      this.previewError = true;
      this.previewErrorMsg = '文件加载失败，请检查网络连接或文件是否存在';
    },

    /**
     * 判断文件是否支持预览
     */
    isSupportPreview(item) {
      if (!item || !item) {
        return false;
      }

      // 如果是对比结果，总是支持预览
      if (item.isCompareResult) {
        return true;
      }

      const fileType = item.fileType;
      return this.$config.supportFile.view.indexOf(fileType) !== -1 ||
        this.$config.supportFile.windowView.indexOf(fileType) !== -1;
    },

    /**
     * 下载文件
     */
    async downloadFile(item) {
      if (!item || !item) {
        return;
      }
      try {
        const downloadUrl = this.$util.getDownloadFileUrl(item.fileId);
        // 使用 fetch 下载文件，避免中文文件名乱码
        const response = await fetch(downloadUrl);
        if (!response.ok) {
          this.$message.error('文件下载失败');
          return;
        }

        // 获取文件内容
        const blob = await response.blob();

        // 使用原始文件名（支持中文）
        const fileName = item.fileName || 'download';

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载文件失败:', error);
        this.$message.error('文件下载失败');
      }
    },

    /**
     * 获取预览URL
     * @param item
     */
    getPreviewUrl(item) {
      if (!item || !item.fileId) {
        return "";
      }

      // 如果是对比结果，直接返回 Blob URL
      if (item.isCompareResult && item.compareUrl) {
        return item.compareUrl;
      }

      const fileInfo = item;
      const token = this.$util.getToken();
      const base = this.$config.system.apiUrl;

      // 浏览器可直接预览的文件类型（PDF、图片等）
      if (this.$config.supportFile.windowView.indexOf(fileInfo.fileType) !== -1) {
        return `${base}/file-info/viewFileByWindow/${item.fileId}?token=${token}`;
      }

      // OnlyOffice 预览的文件类型（Word、Excel、PPT等）
      if (this.$config.supportFile.view.indexOf(fileInfo.fileType) !== -1) {
        return `${base}/file-info/viewFile/${item.fileId}?token=${token}`;
      }

      return "";
    },

    /**
     * 文件夹点击事件
     * @param item
     */
    dbClickFolder(item) {
      // console.log("🚀 ~ item:", item)
      // 如果切换到新文件夹，先记录 结束时间
      if (this.pid) {
        this.recordViewEndTime();
      }
      this.pid = item.id;
      this.folderName = item.name;
      this.previewFile = null;
      this.previewFolder = null; // 先清除旧的文件夹预览
      this.getFolderDetail(item.id)
      //插入面包屑
      this.breadcrumbList.push(item);
      this.refresh();
    },
    getFolderDetail(id) {
      this.$HttpService.post(`/file-folder/detail`, { id: id }).then(res => {
        this.previewFolder = res || {};
      }).catch(() => {
        this.$message.error('加载文件夹详情失败');
      })
      this.$HttpService.post(`/file-info/folder-status`, { id: id }
      ).then(res => {
        this.previewFolderList = res || {};
        // console.log("🚀 ~ this.previewFolderList :", this.previewFolderList)
      }).catch(() => {
        this.$message.error('加载文件夹统计详情失败');
      })
    },

    /**
     * 切换面包屑
     * @param item
     */
    toggleBreadcrumb(item) {
      if (item == null) {
        this.breadcrumbList = [];
        this.pid = 0;
        this.activeMenuId = '';
        this.refresh();
        return;
      }
      // 兼容两种数据结构：左侧菜单使用folderId，右侧文件列表使用id
      const itemId = item.folderId || item.id;

      //找到当前元素的索引
      let index = this.breadcrumbList.findIndex(x => (x.folderId || x.id) === itemId);
      if (index !== -1) {
        // 如果点击的是当前最后一个面包屑，不做任何操作
        if (index === this.breadcrumbList.length - 1) {
          return;
        }
        // 移除当前元素之后的所有元素（保留当前元素）
        this.breadcrumbList.splice(index + 1);
        this.pid = itemId;
        this.folderName = item.name;

        //更新活跃菜单项
        this.activeMenuId = itemId;
        this.refresh();
      }
    },


    /**
     * 解压完成回调-打开解压后的文件夹
     * @param node：文件解压选择的文件夹
     * @param path：节点路径
     */
    decompressionOk({ node, path }) {
      //删除第一个去掉首页
      this.breadcrumbList = path.filter((_, index) => index !== 0);
      this.pid = node.folderId;
      this.refresh();
    },

    /**
     * 复制完成回调-打开复制后的文件夹
     * @param node：文件复制选择的文件夹
     * @param path：节点路径
     */
    copyOk({ node, path }) {
      //删除第一个去掉首页
      this.breadcrumbList = path.filter((_, index) => index !== 0);
      this.pid = node.folderId;
      this.refresh();
    },
    /**
     * 移动回调事件
     * @param node：选择的文件夹
     * @param path：节点路径
     */
    moveOk({ node, path }) {
      //删除第一个去掉首页
      this.breadcrumbList = path.filter((_, index) => index !== 0);
      this.pid = node.folderId;
      this.refresh();
    },

    /**
     * 构建面包屑路径
     * @param folderId 目标文件夹ID
     * @returns 从根到目标文件夹的路径数组
     */
    buildBreadcrumbPath(folderId) {
      // 如果是根目录，返回空数组
      if (folderId === "0" || folderId === 0) {
        return [];
      }

      // 在树形数据中查找路径
      const path = this.findPathInTree(this.treeData, folderId);
      return path || [];
    },

    /**
     * 在树形数据中递归查找路径
     * @param tree 树形数据
     * @param targetId 目标ID
     * @param currentPath 当前路径
     * @returns 找到的路径数组或null
     */
    findPathInTree(tree, targetId, currentPath = []) {
      for (let node of tree) {
        // 将当前节点添加到路径中
        const newPath = [...currentPath, node];

        // 如果找到目标节点，返回路径
        if (node.folderId === targetId) {
          return newPath;
        }

        // 如果有子节点，递归查找
        if (node.children && node.children.length > 0) {
          const result = this.findPathInTree(node.children, targetId, newPath);
          if (result) {
            return result;
          }
        }
      }

      return null;
    },

    /**
     * 打开权限设置对话框
     */
    openPermissionSetting() {
      if (this.previewFolder) {
        // 文件夹权限设置
        this.$refs.folderPermissionDialog.openEditDialog(this.previewFolder.folderId, 0);
      } else {
        // 文件权限设置
        this.$refs.folderPermissionDialog.openEditDialog(this.previewFile.fileId, 1);
      }
    },

    /**
     * 格式化文件大小
     */
    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    showDetail(code) {
      switch (code) {
        case "view":
          this.showViewRecords()
          break
        case "operate":
          this.showOperationRecords()
          break
      }

    },
    showViewRecords() {
      if (!this.previewFile || !this.previewFile.fileId) {
        this.$message.warning('请先选择文件');
        return;
      }

      this.viewRecordsDialog = true;
      this.viewRecordsLoading = true;
      this.viewRecordsData = null;

      this.$HttpService.post('/file-view/readStatus', {
        id: this.previewFile.fileId,
      }).then(res => {
        this.viewRecordsData = res || {};
        this.viewRecordsLoading = false;
      }).catch(() => {
        this.$message.error('获取信息失败');
        this.viewRecordsLoading = false;
      });
    },
    /**
     * 显示操作记录
     */
    showOperationRecords() {
      if (!this.previewFile || !this.previewFile.fileId) {
        this.$message.warning('请先选择文件');
        return;
      }

      this.operationRecordsDialog = true;
      // 重置分页信息
      this.operationRecordsPagination.curPage = 1;
      this.operationRecordsPagination.pageSize = 50;
      // 加载操作记录
      this.loadOperationRecords();
    },

    /**
     * 加载操作记录
     */
    loadOperationRecords() {
      this.operationRecordsLoading = true;
      this.operationRecordsList = [];

      // 调用接口获取操作记录
      this.$HttpService.post('/file-view/list', {
        fileId: this.previewFile.fileId,
        curPage: this.operationRecordsPagination.curPage,
        pageSize: this.operationRecordsPagination.pageSize
      }).then(res => {
        this.operationRecordsList = res.records || [];
        this.operationRecordsPagination.total = res.total || 0;
        this.operationRecordsLoading = false;
      }).catch(() => {
        this.$message.error('获取操作记录失败');
        this.operationRecordsLoading = false;
      });
    },

    /**
     * 操作记录分页大小改变
     */
    handleOperationRecordsSizeChange(val) {
      this.operationRecordsPagination.pageSize = val;
      this.operationRecordsPagination.curPage = 1;
      this.loadOperationRecords();
    },

    /**
     * 操作记录页码改变
     */
    handleOperationRecordsPageChange(val) {
      this.operationRecordsPagination.curPage = val;
      this.loadOperationRecords();
    },

    /**
     * 表格序号计算
     */
    indexMethod(index) {
      return (this.operationRecordsPagination.curPage - 1) * this.operationRecordsPagination.pageSize + index + 1;
    },

    /**
     * 格式化时长（秒转换为时分秒）
     */
    formatDuration(seconds) {
      if (!seconds || seconds === 0) return '0秒';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      let result = '';
      if (hours > 0) result += `${hours}小时`;
      if (minutes > 0) result += `${minutes}分`;
      if (secs > 0 || result === '') result += `${secs}秒`;

      return result;
    },

    /**
     * 记录查看文件开始时间
     */
    recordViewStartTime() {
      if (!this.previewFile || !this.previewFile.fileId) {
        return;
      }

      // 如果是对比结果，不记录查看时间
      if (this.previewFile.isCompareResult) {
        return;
      }

      // 格式化当前时间为 yyyy-MM-dd HH:mm:ss
      const now = new Date();
      this.currentViewStartTime = this.formatDateTime(now);

      // 调用接口记录开始时间
      this.$HttpService.post('/file-view/insert', {
        fileId: this.previewFile.fileId,
        type: 1, // 1-查看
        username: this.userInfo.username || this.userInfo.name,
        startTime: this.currentViewStartTime
      }).then(() => {
        // console.log('记录查看开始时间成功:', this.currentViewStartTime);
      }).catch(err => {
        console.error('记录查看开始时间失败:', err);
      });
    },

    /**
     * 记录查看文件结束时间
     * @param callback 可选的回调函数，在记录完成后调用
     */
    recordViewEndTime(callback) {
      // console.log('recordViewEndTime 被调用，callback:', typeof callback);

      if (!this.previewFile || !this.previewFile.fileId || !this.currentViewStartTime) {
        // console.log('没有需要记录的内容，直接调用回调');
        // 如果没有需要记录的内容，直接调用回调
        if (callback && typeof callback === 'function') {
          callback();
        }
        return;
      }

      // 如果是对比结果，不记录查看时间
      if (this.previewFile.isCompareResult) {
        // console.log('对比结果不记录查看时间');
        if (callback && typeof callback === 'function') {
          callback();
        }
        return;
      }

      // console.log('开始记录结束时间，fileId:', this.previewFile.fileId);

      // 调用接口记录结束时间
      this.$HttpService.post('/file-view/updateEndTime', {
        fileId: this.previewFile.fileId,
        type: 1, // 1-查看
        username: this.userInfo.username || this.userInfo.name,
        startTime: this.currentViewStartTime
      }).then(() => {
        // console.log('记录查看结束时间成功，调用回调');
        this.currentViewStartTime = null;
        // 记录成功后调用回调
        if (callback && typeof callback === 'function') {
          callback();
        }
      }).catch(err => {
        console.error('记录查看结束时间失败:', err);
        // 即使失败也调用回调，避免阻塞退出登录
        if (callback && typeof callback === 'function') {
          callback();
        }
      });
    },

    /**
     * 格式化日期时间为 yyyy-MM-dd HH:mm:ss
     */
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    /**
     * 打开全屏预览
     */
    openFullScreenPreview() {
      if (!this.previewFile) {
        this.$message.warning('请先选择文件');
        return;
      }

      if (!this.isSupportPreview(this.previewFile)) {
        this.$message.warning('该文件类型不支持预览');
        return;
      }

      this.fullScreenPreviewDialog = true;
      this.fullScreenPreviewLoading = true;
      this.fullScreenPreviewError = false;
      this.fullScreenPreviewErrorMsg = '';
      this.fullScreenZoom = 100;
      this.fullScreenPreviewKey++;
    },

    /**
     * 关闭全屏预览
     */
    closeFullScreenPreview() {
      this.fullScreenPreviewDialog = false;
      this.fullScreenPreviewLoading = false;
      this.fullScreenPreviewError = false;
      this.fullScreenPreviewErrorMsg = '';
      this.fullScreenZoom = 100;
    },

    /**
     * 全屏预览放大
     */
    fullScreenZoomIn() {
      if (this.fullScreenZoom < 200) {
        this.fullScreenZoom += 10;
      }
    },

    /**
     * 全屏预览缩小
     */
    fullScreenZoomOut() {
      if (this.fullScreenZoom > 10) {
        this.fullScreenZoom -= 10;
      }
    },

    /**
     * 全屏预览重置缩放
     */
    fullScreenResetZoom() {
      this.fullScreenZoom = 100;
    },

    /**
     * 全屏预览加载完成
     */
    onFullScreenPreviewLoad() {
      this.fullScreenPreviewLoading = false;
    },

    /**
     * 确认新增文件夹
     */
    confirmAddFolder() {
      this.$refs.addFolderFormRef.validate(valid => {
        if (!valid) return;
        this.addFolderLoading = true;
        this.$HttpService.post('/file-folder/add', {
          parentId: this.pid,
          folderName: this.addFolderForm.folderName,
          publicFlag: 0
        }).then(() => {
          this.$message.success('新增文件夹成功');
          this.addFolderDialogVisible = false;
          this.addFolderForm.folderName = '';
          this.refresh();
        }).catch(() => {
          this.$message.error('新增文件夹失败');
        }).finally(() => {
          this.addFolderLoading = false;
        });
      });
    },

    /**
     * 上传文件变化处理
     */
    handleUploadChange(file, fileList) {
      this.uploadFileList = fileList;
    },

    /**
     * 移除上传文件
     */
    handleUploadRemove(file, fileList) {
      this.uploadFileList = fileList;
    },

    /**
     * 确认上传
     */
    confirmUpload() {
      if (this.uploadFileList.length === 0) {
        this.$message.warning('请先选择要上传的文件');
        return;
      }

      this.uploading = true;

      // 创建FormData
      const formData = new FormData();
      this.uploadFileList.forEach(item => {
        formData.append('file', item.raw);
      });
      formData.append('folderId', this.pid);

      // 调用上传接口
      this.$HttpService.post('/file-info/uploadFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.$message.success(`成功上传 ${this.uploadFileList.length} 个文件`);
        this.uploadDialogVisible = false;
        this.uploadFileList = [];
        this.uploading = false;
        // 刷新文件列表
        this.refresh();
      }).catch(err => {
        console.error('上传失败:', err);
        this.$message.error('上传失败，请稍后重试');
        this.uploading = false;
      });
    },

    /**
     * 全屏预览加载错误
     */
    onFullScreenPreviewError() {
      this.fullScreenPreviewLoading = false;
      this.fullScreenPreviewError = true;
      this.fullScreenPreviewErrorMsg = '文件加载失败，请检查网络连接或文件是否存在';
    },

    /**
     * 刷新全屏预览
     */
    refreshFullScreenPreview() {
      this.fullScreenPreviewLoading = true;
      this.fullScreenPreviewError = false;
      this.fullScreenPreviewErrorMsg = '';
      this.fullScreenPreviewKey++;
    },
    // 进入批量审批模式
    enterBatchApprovalMode() {
      // console.log('myFile enterBatchApprovalMode called');
      this.$set(this, 'batchApprovalMode', true);
      this.selectedFiles = [];
      // console.log('batchApprovalMode set to:', this.batchApprovalMode);
      this.$message.info('请勾选需要提交审批的草稿文件');
      this.$forceUpdate();
    },

    // 取消批量审批模式
    cancelBatchApproval() {
      this.batchApprovalMode = false;
      this.selectedFiles = [];
    },

    // 处理文件勾选变化
    handleFileCheckChange({ checked, fileInfo }) {
      if (checked) {
        // 添加到选中列表
        if (!this.selectedFiles.find(f => f.fileId === fileInfo.fileId)) {
          this.selectedFiles.push(fileInfo);
        }
      } else {
        // 从选中列表移除
        this.selectedFiles = this.selectedFiles.filter(f => f.fileId !== fileInfo.fileId);
      }
    },

    // 确认批量提交审批
    confirmBatchApproval() {
      if (this.selectedFiles.length === 0) {
        this.$message.warning('请至少选择一个文件');
        return;
      }

      // 构造批量审批数据
      const fileId = this.selectedFiles.map(f => f.fileId)

      // 打开审批弹窗
      this.$refs.initiateApprovalModal.open(fileId);

      // 退出批量模式
      this.batchApprovalMode = false;
      this.selectedFiles = [];
    },

    // 进入文件对比模式
    enterCompareMode() {
      // console.log('进入文件对比模式');
      this.compareMode = true;
      this.compareFiles = [];
      this.$message.info('请勾选两个文件进行对比');
      // 强制更新视图
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    // 取消文件对比模式
    cancelCompare() {
      this.compareMode = false;
      this.compareFiles = [];
    },

    // 处理对比文件勾选变化
    handleCompareCheckChange({ checked, fileInfo }) {
      // console.log('myFileTree handleCompareCheckChange:', checked, fileInfo, 'current compareFiles:', this.compareFiles);

      if (checked) {
        // 最多只能选择2个文件
        if (this.compareFiles.length >= 2) {
          this.$message.warning('最多只能选择2个文件进行对比');
          // 强制取消勾选 - 通过重置 compareMode 来触发子组件更新
          this.$nextTick(() => {
            this.$forceUpdate();
          });
          return;
        }
        // 添加到选中列表
        if (!this.compareFiles.find(f => f.fileId === fileInfo.fileId)) {
          this.compareFiles.push(fileInfo);
          // console.log('添加文件到对比列表:', fileInfo.fileName, '当前数量:', this.compareFiles.length);
        }
      } else {
        // 从选中列表移除
        this.compareFiles = this.compareFiles.filter(f => f.fileId !== fileInfo.fileId);
        // console.log('从对比列表移除文件:', fileInfo.fileName, '当前数量:', this.compareFiles.length);
      }
    },

    // 确认文件对比
    confirmCompare() {
      if (this.compareFiles.length !== 2) {
        this.$message.warning('请选择两个文件进行对比');
        return;
      }

      const oldFileId = this.compareFiles[0].fileId;
      const newFileId = this.compareFiles[1].fileId;

      // 调用对比接口
      this.loading = true;

      // 构建完整的 URL（直接作为 iframe src，让浏览器原生加载 HTML 及其资源）
      const token = this.$util.getToken();
      const base = this.$config.system.apiUrl;
      const compareUrl = `${base}/file-info/compare/${oldFileId}/${newFileId}?token=${token}`;

      // 先保存文件名，避免清空数组后无法访问
      const compareFileName = `${this.compareFiles[0].fileName} vs ${this.compareFiles[1].fileName}`;

      // 退出对比模式（先清空，避免响应式问题）
      this.compareMode = false;
      this.compareFiles = [];

      // 直接将对比接口 URL 作为 iframe src，浏览器可正常加载 HTML 中的外部资源
      this.previewFile = {
        fileId: 'compare-result',
        fileName: compareFileName,
        fileType: 'html',
        isCompareResult: true,
        compareUrl: compareUrl
      };

      // 强制刷新 iframe
      this.previewKey++;
      this.$message.success('文件对比成功');
      this.loading = false;
    },
  }
}
</script>

<style scoped lang="scss">
.menu {
  background-color: #F5F6F7;
  width: 226px;

  // 管理员模式高度
  &.menu-admin {
    height: calc(100vh - 120px);

    ::v-deep .my_el_menu:not(.el-menu--collapse) {
      width: 226px;
      height: calc(100vh - 120px);
      overflow: hidden auto;
    }
  }

  // 普通用户模式高度
  &.menu-user {
    height: calc(100vh - 50px);

    ::v-deep .my_el_menu:not(.el-menu--collapse) {
      width: 226px;
      height: calc(100vh - 50px);
      overflow: hidden auto;
    }
  }

  .my_el_menu {
    border: 0px !important;
  }

  // 设置活跃菜单项的背景颜色
  ::v-deep .el-menu-item.is-active {
    background-color: #ddeaff !important;
    border-radius: 10px;
    // margin: 0 10px
  }

  // 设置活跃子菜单标题的背景颜色
  ::v-deep .el-submenu.is-active>.el-submenu__title {
    background-color: #ddeaff !important;
  }
}

.myFileBox {
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;



  .top {
    padding: 10px;
    background: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;

    ::v-deep .el-breadcrumb {
      .el-breadcrumb__inner {
        cursor: pointer;
      }

      .el-breadcrumb__inner:hover {
        color: #29AAE3;
      }
    }

  }

  .panel {
    width: 100%;
    flex: 1;
    padding: 0px 8px;
    overflow-y: auto;
    height: calc(100vh - 180px);

    .fileBox {
      width: 100%;

      .box {
        width: 100%;
      }
    }
  }

  .panel-admin {
    width: 100%;
    flex: 1;
    padding: 0px 8px;
    overflow-y: auto;

    .fileBox {
      width: 100%;

      .box {
        width: 100%;
      }
    }

    // height: calc(100vh - 375px);
  }


  ::v-deep .filter-tree {
    padding: 10px;
    height: 100%;
    overflow-y: auto;
  }

}

// 批量操作按钮样式
.batch-approval-actions,
.compare-actions {
  padding: 10px;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

// 高级搜索面板样式
.advanced-search-panel {
  padding: 15px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-top: 10px;

  ::v-deep .el-form {
    margin-bottom: 0;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__label {
      color: #606266;
      font-weight: 500;
    }
  }
}

// 预览面板样式
.preview-panel {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-left: 1px solid #e0e0e0;

  .preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    border-bottom: 1px solid #e0e0e0;
    background: #fafafa;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);



    .preview-title {
      font-size: 14px;
      font-weight: 500;
      color: #333;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .preview-tags {
      margin: auto;
    }

    .preview-actions {
      display: flex;
      align-items: center;
      gap: 5px;

      .el-button {
        // font-size: 16px;
        padding: 8px;

        &:hover {
          color: #409eff;
        }
      }
    }
  }

  .numBox {

    display: flex;

    .top-title {
      display: flex;
      align-items: center;
      color: #6f7588;
      font-size: 14px;

      .count-title {
        min-width: 50px;
        margin-left: 5px;
      }
    }

    .count {
      color: #6f7588;
      margin-left: 5px;
      font-size: 14px;
    }
  }

  .preview-content {
    flex: 1;
    height: 100%;
    overflow: hidden;
    position: relative;
    background: #f5f5f5;

    .preview-iframe {
      width: 100%;
      height: 100%;
      border: none;
      background: #fff;
    }

    .preview-error,
    .preview-unsupported {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
    }
  }

  .preview-bottom {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eeeff0;
    padding: 15px 20px;

    .preview-bottom-left {
      display: flex;

      gap: 20px;
      align-items: center;
      flex-wrap: wrap;
    }
  }

  // 缩放控制样式
  .zoom-controls {
    display: flex;
    align-items: center;
    gap: 12px;

    .zoom-label {
      display: flex;
      align-items: center;
      color: #6f7588;
      font-size: 14px;
      gap: 5px;

      i {
        font-size: 16px;
        color: #1e6fff;
      }
    }

    .el-button-group {
      display: flex;

      .el-button {
        padding: 7px 12px;
        font-size: 12px;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }
}

// 文件夹详情样式
.folder-detail-content {
  padding: 24px;
  overflow-y: auto;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);

  .folder-info-section {
    background: #fff;
    border-radius: 12px;
    padding: 28px;
    margin-bottom: 24px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    border: 1px solid rgba(64, 158, 255, 0.1);

    // &:hover {
    //   box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
    //   transform: translateY(-2px);
    // }

    .section-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 3px solid transparent;
      background: linear-gradient(to right, #409eff 0%, #67c23a 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 3px;
        background: linear-gradient(to right, #409eff, #67c23a);
        border-radius: 2px;
      }

      i {
        font-size: 20px;
        margin-right: 10px;
        color: #409eff;
        -webkit-text-fill-color: initial;
      }
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }

      .info-item {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 16px;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border-radius: 10px;
        border: 1px solid #e8ecf1;
        transition: all 0.3s ease;

        // &:hover {
        //   background: linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%);
        //   border-color: #409eff;
        //   transform: translateX(4px);
        //   box-shadow: 0 2px 12px rgba(64, 158, 255, 0.15);
        // }

        .info-label {
          display: flex;
          align-items: center;
          font-size: 13px;
          color: #606266;
          font-weight: 600;
          letter-spacing: 0.3px;

          i {
            font-size: 18px;
            margin-right: 8px;
            opacity: 0.85;
          }
        }

        .info-value {
          font-size: 15px;
          color: #303133;
          padding-left: 26px;
          font-weight: 600;
          letter-spacing: 0.2px;
        }
      }
    }

    .permissions-info {
      padding: 12px 0;

      .el-tag {
        padding: 8px 16px;
        font-size: 13px;
        border-radius: 6px;
      }
    }
  }

  .folder-stats-section {
    background: #fff;
    border-radius: 12px;
    padding: 28px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    border: 1px solid rgba(64, 158, 255, 0.1);

    &:hover {
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    .section-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 3px solid transparent;
      background: linear-gradient(to right, #409eff 0%, #67c23a 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 60px;
        height: 3px;
        background: linear-gradient(to right, #409eff, #67c23a);
        border-radius: 2px;
      }

      i {
        font-size: 20px;
        margin-right: 10px;
        color: #409eff;
        -webkit-text-fill-color: initial;
      }
    }

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }

      .stat-card {
        display: flex;
        align-items: center;
        padding: 20px;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border-radius: 12px;
        border: 1px solid #e8ecf1;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;

          i {
            font-size: 24px;
            color: #fff;
          }
        }

        .stat-info {
          flex: 1;

          .stat-label {
            font-size: 12px;
            color: #909399;
            margin-bottom: 4px;
          }

          .stat-value {
            font-size: 20px;
            font-weight: 600;
            color: #303133;
          }
        }
      }
    }
  }
}

.empty-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-left: 1px solid #e0e0e0;
}

// 全屏预览对话框样式
::v-deep .fullscreen-preview-dialog {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    height: 100vh;
    overflow: hidden;
  }

  .fullscreen-preview-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .fullscreen-toolbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      z-index: 10;

      .toolbar-left {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;

        .file-name {
          font-size: 16px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .toolbar-right {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }

    .fullscreen-preview-content {
      flex: 1;
      height: calc(100vh - 56px);
      overflow: hidden;
      position: relative;
      background: #1a1a1a;

      .fullscreen-preview-iframe {
        width: 100%;
        height: 100%;
        border: none;
        background: #fff;
      }

      .preview-error,
      .preview-unsupported {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2c3e50;

        ::v-deep .el-result__title,
        ::v-deep .el-result__subtitle {
          color: #ecf0f1;
        }
      }
    }
  }
}

// 上传弹窗样式
::v-deep .upload-demo {
  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .el-icon-upload {
      font-size: 67px;
      color: #c0c4cc;
      margin: 0;
      line-height: 1;
    }

    .el-upload__text {
      color: #606266;
      font-size: 14px;
      text-align: center;
      margin-top: 20px;

      em {
        color: #409eff;
        font-style: normal;
      }
    }
  }

  .el-upload-list {
    margin-top: 10px;
  }
}

// 查看记录弹窗样式
.view-records-container {
  padding: 10px;

  .statistics-section {
    margin-bottom: 24px;

    .stat-card {
      display: flex;
      align-items: center;
      padding: 20px;
      // background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      cursor: pointer;

      // &:hover {
      //   transform: translateY(-4px);
      //   box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      // }

      .stat-icon {
        // width: 56px;
        // height: 56px;
        // border-radius: 12px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // margin-right: 16px;
        // font-size: 28px;
        // color: #fff;

        &.total {
          color: #667eea;
        }

        &.read {
          color: #67c23a
        }

        &.unread {
          color: #f1a839
        }
      }

      .stat-content {
        flex: 1;

        .stat-label {
          font-size: 14px;
          color: #909399;
          margin-bottom: 8px;
          font-weight: 500;
        }

        .stat-value {
          font-size: 28px;
          font-weight: 600;
          color: #303133;
          line-height: 1;
        }
      }
    }
  }

  .user-list-section {
    width: 48%;
    margin-bottom: 24px;
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .section-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 2px solid #f0f0f0;
      font-size: 16px;
      font-weight: 600;
      color: #303133;

      i {
        font-size: 18px;
        margin-right: 8px;
        color: #409eff;
      }
    }

    .user-list {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      min-height: 60px;
      max-height: calc(100vh - 400px);
      overflow: auto;

      .user-tag {
        padding: 8px 16px;
        font-size: 14px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }

        i {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
